module.exports = __webpack_public_path__ + "static/media/10.bf4de0a0.jpg";